import _ from 'lodash'
import { PRODUCT_LINE, PRODUCT_LINES } from '@/constant'

const selectedDataDefault = () => {
  return {
    playDate: { dateSeries: [], startEndDates: [] },
    flvSecond: null,
    frequency: 2,
    demographics: [],
    hourlies: [],
    interestKeyword: {
      type: 'interest',
      interestIds: [],
      keywordIds: []
    },
    media: {
      isPrime: 0,
      includeIds: [],
      excludeIds: []
    },
    platformType: 'speedDmp',
    cities: {
      regions: [],
      municipalities: []
    },
    isps: [],
    deviceBrands: [],
    budgetReach: {
      type: 'budget',
      minimumBudget: 0,
      budget: {
        value: 100000,
        format: {}
      },
      reach: {
        value: 50,
        format: {}
      }
    },
    condition: {
      // ad_format 只給前端暫存用
      ad_format: [],
      ad_format_types: [],
      // speed 固定帶給後端的資料
      placement_type_id: 2,
      flv_second: null,
      freq: 2,
      media: {
        is_prime: 0,
        media_ids: []
      }
    }
  }
}
// 預設的空選擇資料
const defaultSelectedData = () => {
  let SIData = selectedDataDefault()
  SIData.condition = {
    ...SIData.condition,
    pick_product_line: 1,
    product_line_id: 9
  }
  let LINEData = selectedDataDefault()
  LINEData.condition = {
    ...LINEData.condition,
    pick_product_line: 3,
    product_line_id: 4
  }
  let SVData = selectedDataDefault()
  SVData = {
    ...SVData,
    mediaType: ''
  }
  SVData.condition = {
    ...SVData.condition,
    pick_product_line: 2,
    product_line_id: 10 // 10, 11, 12
  }
  return {
    SuperImpact: SIData,
    SuperView: SVData,
    LINEToday: LINEData
  }
}

// 這邊放的都是純函式
// options from api
const getDefaultFlvSecond = (options) => {
  return PRODUCT_LINES.reduce((map, productName) => {
    map[productName] = options[productName].list[0].flv_second[0].id
    return map
  }, {})
}

const getDefaultHourlies = (options) => {
  const allIds = options.map(option => option.id)
  return PRODUCT_LINES.reduce((map, productName) => {
    map[productName] = allIds
    return map
  }, {})
}

const getDefaultMedia = () => {
  return PRODUCT_LINES.reduce((map, productName) => {
    map[productName] = {
      isPrime: 0,
      includeIds: [],
      excludeIds: []
    }
    return map
  }, {})
}

const getDefaultBudgetReach = (userIsReseller) => {
  return PRODUCT_LINES.reduce((map, productName) => {
    let minimumBudget = 0
    switch (productName) {
      case PRODUCT_LINE.SUPER_IMPACT:
      case PRODUCT_LINE.SUPER_VIEW:
        minimumBudget = userIsReseller ? 50000 : 100000
        break
      case PRODUCT_LINE.LINE_TODAY:
        minimumBudget = 100000
        break
    }
    map[productName] = {
      type: 'budget',
      minimumBudget,
      budget: {
        value: minimumBudget
      },
      reach: {
        value: 50
      }
    }
    return map
  }, {})
}

const getDefaultFormatSelector = () => {
  return getEmptyArray()
}

// helper function
const getEmptyArray = () => {
  return PRODUCT_LINES.reduce((map, productName) => {
    map[productName] = []
    return map
  }, {})
}

const getDefaultSelectedData = (options, rootGetters) => {
  const baseSelectedData = defaultSelectedData()
  let tmpSelectedData = _.cloneDeep(baseSelectedData)
  const defaultFlvSecond = getDefaultFlvSecond(options.product_lines)
  const defaultHourlies = getDefaultHourlies(options.hourlies)
  const defaultMedia = getDefaultMedia()
  const defaultBudgetReach = getDefaultBudgetReach(rootGetters['root/userIsReseller'])
  const defaultFormatSelector = getDefaultFormatSelector()

  PRODUCT_LINES.forEach(productName => {
    tmpSelectedData[productName].flvSecond = defaultFlvSecond[productName]
    // 解掉 flv_second 在重設選項後，不會更新到 condition 的問題，因為舊有選項和重給的選項一樣
    // 不會觸發 flvsecond.vue 裡面的 watch value, 就沒有更新到 condition.flv_secon
    tmpSelectedData[productName].condition.flv_second = defaultFlvSecond[productName]
    tmpSelectedData[productName].hourlies = defaultHourlies[productName]
    tmpSelectedData[productName].media = defaultMedia[productName]
    tmpSelectedData[productName].budgetReach = defaultBudgetReach[productName]
    tmpSelectedData[productName].condition.ad_format = defaultFormatSelector[productName]
  })

  tmpSelectedData[PRODUCT_LINE.SUPER_VIEW].mediaType = ''

  return tmpSelectedData
}

export default {
  getDefaultSelectedData,
  getDefaultFlvSecond,
  getDefaultHourlies,
  getDefaultMedia,
  getDefaultBudgetReach,
  getDefaultFormatSelector
}
